import React from 'react'
import Layouts from '../components/Layouts'
import moment from 'moment'
import { Button, DatePicker, message, Row, Table, Col } from 'antd'
import * as xlsx from 'xlsx'
import * as FileSaver from 'file-saver'
import { Spin } from 'antd'
import apiRequest from '../hooks/ApiRequest'
import hasPermissions from '../hooks/Permissions'

var today = new Date()
var priorDate = new Date(new Date().setDate(today.getDate() - 30))
class reports extends React.Component {
  constructor() {
    super()
    this.state = {
      startDate: priorDate,
      endDate: new Date(),
      dateFormat: 'YYYY-MM-DD',
      currentDate: new Date(),
      policyData: [],
      exportData: [],
      productname: localStorage.getItem('productName'),
      loading: false,
      productId: parseInt(localStorage.getItem('productId')),
      policyPermissions: {},
      columns: [
        {
          key: '1',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '2',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: '3',
          title: 'Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: '4',
          title: 'End Date',
          dataIndex: 'policyexpirytdate',
        },
        // {
        //   key: '5',
        //   title: 'Annual Premium',
        //   dataIndex: 'grandtotalannualpremium',
        // },
        {
          key: '6',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
        },
        {
          key: '7',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: '8',
          title: 'Created Date',
          dataIndex: 'createddate',
          render: createddate => moment(createddate).format('YYYY-MM-DD'),
        },
      ],
      columnsForFCP: [
        {
          key: '1',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '2',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: '3',
          title: 'Start Date',
          dataIndex: 'policystartdate',
        },
        // {
        //   key: '4',
        //   title: 'End Date',
        //   dataIndex: 'policyexpirytdate',
        // },
        // {
        //   key: '5',
        //   title: 'Annual Premium',
        //   dataIndex: 'grandtotalannualpremium',
        // },
        {
          key: '6',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
        },
        {
          key: '7',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: '8',
          title: 'Created Date',
          dataIndex: 'createddate',
          render: createddate => moment(createddate).format('YYYY-MM-DD'),
        },
      ],
    }
    this.startDateChange = this.startDateChange.bind(this)
    this.endDateChange = this.endDateChange.bind(this)
    this.policiesInDateRange = this.policiesInDateRange.bind(this)
    this.handleExport = this.handleExport.bind(this)
  }

  componentDidMount() {
    const permissions = hasPermissions("Policy");

    this.setState({ policyPermissions: permissions }, () => {
      console.log("Saved Policy permissions", this.state.policyPermissions);
    });
  }

  startDateChange(date, datestring) {
    if (datestring === '') {
      message.warning('Start date cannot be null')
    } else {
      this.setState({ startDate: new Date(datestring) })
    }
  }
  endDateChange(date, datestring) {
    if (new Date(datestring) < new Date(this.state.currentDate)) {
      this.setState({ endDate: new Date(datestring) })
    } else if (datestring === '') {
      message.warning('End date cannot be null')
    } else {
      message.warning('End date cannot be greater than current date')
    }
  }
  // policiesInDateRange() {
  //   this.setState({ loading: true })
  //   var endDateText = this.state.endDate.toISOString()
  //   var finalEndDate = endDateText.substring(0, endDateText.length - 14)
  //   var startDateText = this.state.startDate.toISOString()
  //   var finalStartDate = startDateText.substring(0, startDateText.length - 14)
  //   fetch(
  //     process.env.REACT_APP_BASE_URL +
  //     '/Policy/GetPolicyByDate?startDate=' +
  //     finalStartDate +
  //     '&endDate=' +
  //     finalEndDate +
  //     '&productid=' +
  //     this.state.productId
  //   )
  //     .then(res => res.json())
  //     .then(data => {
  //       this.setState({ policyData: data })
  //       this.setState({ loading: false })
  //     })
  //   this.setState({ loading: false })
  // }
  policiesInDateRange = async () => {
    this.setState({ loading: true });

    try {
      const finalStartDate = this.state.startDate.toISOString().slice(0, 10);
      const finalEndDate = this.state.endDate.toISOString().slice(0, 10);

      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicyByDate?startDate=${finalStartDate}&endDate=${finalEndDate}&productid=${this.state.productId}`,
        'GET'
      );

      if (response?.success) {
        this.setState({ policyData: response?.data?.result });
      }
    } catch (error) {
      console.error("Error fetching policies by date range:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleExport() {
    var jsonObj = []
    for (let i = 0; i < this.state.policyData.length; i++) {
      jsonObj[i] = {
        'Customer Name': this.state.policyData[i].customername,
        'Policy Number': this.state.policyData[i].policynumber,
        'Start Date': this.state.policyData[i].policystartdate,
        'End Date': this.state.policyData[i].policyexpirytdate,
        Premium: this.state.policyData[i].proratatotaltermpremium,
        Status: this.state.policyData[i].policystatus,
        'Created Date': moment(this.state.policyData[i].createddate).format(
          'YYYY-MM-DD',
        ),
      }
    }
    const fileType = 'xlsx'
    const ws = xlsx.utils.json_to_sheet(jsonObj)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, 'Policies' + '.xlsx')
  }

  render() {
    return (
      <Layouts title="assets" classname="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  {this.state.productname} POLICY REPORT
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div className=" dash-bg-white">
          <div className="m-b-20">
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} md={12} lg={20} className="custom-statcards">
                <label>Start Date: </label>
                <DatePicker
                  value={moment(this.state.startDate, this.state.dateFormat)}
                  onChange={this.startDateChange}
                />{' '}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label>End Date: </label>
                <DatePicker
                  value={moment(this.state.endDate, this.state.dateFormat)}
                  onChange={this.endDateChange}
                />{' '}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {this.state.policyPermissions.hasOwnProperty("16") && (<Button
                  style={{
                    marginLeft: 'auto',
                    color: '#fd7e14',
                    borderColor: '#fd7e14',
                  }}
                  onClick={this.policiesInDateRange}>
                  Search{' '}
                </Button>)}
              </Col>
              <Col xs={24} sm={12} md={12} lg={4} className="custom-statcards">
                {this.state.policyData.length > 0 && (
                  <div className="text-right-export">
                    <Button
                      style={{
                        marginLeft: 'auto',
                        color: '#5cb85c',
                        borderColor: '#5cb85c',
                      }}
                      onClick={this.handleExport}>
                      Export{' '}
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
        {this.state.policyData.length > 0 && (
          <div className="table-grid-bx">
            <Table
              className="table-scroll-auto"
              columns={
                this.state.productId !== 3
                  ? this.state.columns
                  : this.state.columnsForFCP
              }
              dataSource={this.state.policyData}
              pagination={false}
            />
          </div>
        )}
      </Layouts>
    )
  }
}

export default reports
